export enum Z_INDEX {
  INDEX_1 = 1,
  ADDITIONAL_TABLE_FILTERS = 4,
  BACKDROP = 100,
  COMMAND_MENU = 10,
  COMMENT_ICON = 1,
  CONTEXT_MENU = 10,
  CHECKBOX = 1,
  DATE_PICKER = 1050,
  DROPDOWN = 2,
  DYNAMIC_MOBILE_TABLE = 3,
  DYNAMIC_MOBILE_TABLE_FOOTER = 3,
  FORM_SELECT_CONTROL = 2,
  FORM_SELECT_MENU = 4,
  FORM_SELECT_INDEX = 2000,
  FORM_SELECT_BACKDROP = 1999,
  FILTER_MENU_OVERLAY = 100,
  FLOATING_LABEL = 3,
  MENU_PORTAL = 2000,
  MENU_PORTAL_OVERLAY = 2001,
  MOBILE_SIDEBAR = 4,
  NAVIGATION_TAB = 1,
  NAVIGATION_TAB_INDICATOR = 2,
  PASSWORD_TOGGLE_BUTTON = 2,
  RIGHT_CLICK_DROPDOWN = 11,
  RISK_SEGMENT_HOVER = 10,
  STICKY_STYLED_TABLE = 3,
  STICKY_MOBILE_STYLED_HEAD = 3,
  TOOLTIPS = 100,
}
